var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInjury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11459 10.8247L10.8247 5.11459L8.89277 3.18261C7.31595 1.6058 4.75943 1.6058 3.18261 3.18261C1.6058 4.75943 1.6058 7.31595 3.18261 8.89277L5.11459 10.8247Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8854 6.17523L6.17523 11.8854L12.1146 17.8247L17.8247 12.1146L11.8854 6.17523ZM11.2928 9.87896C10.9022 9.48844 10.9022 8.85527 11.2928 8.46475C11.6833 8.07422 12.3165 8.07422 12.707 8.46475C13.0975 8.85527 13.0975 9.48844 12.707 9.87896C12.3165 10.2695 11.6833 10.2695 11.2928 9.87896ZM8.46438 12.7074C8.07386 12.3168 8.07386 11.6837 8.46438 11.2931C8.85491 10.9026 9.48807 10.9026 9.8786 11.2931C10.2691 11.6837 10.2691 12.3168 9.8786 12.7074C9.48807 13.0979 8.85491 13.0979 8.46438 12.7074ZM14.1213 11.2931C14.5118 10.9026 15.145 10.9026 15.5355 11.2931C15.926 11.6837 15.926 12.3168 15.5355 12.7074C15.145 13.0979 14.5118 13.0979 14.1213 12.7074C13.7307 12.3168 13.7307 11.6837 14.1213 11.2931ZM11.2928 15.5357C10.9022 15.1452 10.9022 14.512 11.2928 14.1215C11.6833 13.731 12.3165 13.731 12.707 14.1215C13.0975 14.512 13.0975 15.1452 12.707 15.5357C12.3165 15.9262 11.6833 15.9262 11.2928 15.5357Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8174 15.1072C22.3942 16.684 22.3942 19.2406 20.8174 20.8174C19.2406 22.3942 16.684 22.3942 15.1072 20.8174L13.1753 18.8854L18.8854 13.1753L20.8174 15.1072Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8174 8.89277L18.7708 10.9393L13.0607 5.22919L15.1072 3.18261C16.684 1.6058 19.2406 1.6058 20.8174 3.18261C22.3942 4.75943 22.3942 7.31595 20.8174 8.89277Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22918 13.0607L3.18261 15.1072C1.6058 16.6841 1.6058 19.2406 3.18261 20.8174C4.75943 22.3942 7.31595 22.3942 8.89277 20.8174L10.9393 18.7708L5.22918 13.0607Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjury);
export default __webpack_public_path__ + "static/media/injury.2d0a47107b029864f9e5c36456217ded.svg";
export { ForwardRef as ReactComponent };